import { initializeChakraComponent } from 'Shared/chakra-initialize';
import ChooseAskDevice from './choose_ask_device';

const ChooseAskDeviceRoot = props => <ChooseAskDevice {...props} />;

initializeChakraComponent('ChooseAskDevice', ChooseAskDeviceRoot);
